import React, { useEffect, useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import IosShareIcon from '@mui/icons-material/IosShare';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { useNavigate, useParams } from 'react-router-dom';
import { Esercizio, esercizioVuoto } from '../interfaces/Esercizio';
import EsercizioDetailsTable from '../components/EsercizioDetailsTable';
import CompartiMuscolari from '../components/CompartiMuscolari';
import { MODALTYPE, ModalData, modalDataClean, ModalAlert } from '../components/ModalAlert';
import SpinnerODM from '../components/spinnerODM';

//interface EsercizioPageVProps {
//  token: string;
//}

const EsercizioPageV: React.FC = () => {

  const { id } = useParams<{ id: string }>();
  const [esercizio, setEsercizio] = useState<Esercizio>(esercizioVuoto);
  const [modalData, setModalData] = useState<ModalData>(modalDataClean);
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);


  useEffect(() => {
    setLoading(true)
    if (id) {
      const headers = new Headers();
      //if (token) {
      //  headers.set('Authorization', `Token ${token}`);
      //}
      headers.set('Accept', 'application/json');
      const requestInit: RequestInit = {
        method: 'GET',
        headers: headers,
        credentials: 'include',
      }
      fetch(`/api/v0/activity/${id}`, requestInit)
        .then(response => response.json())
        .then(data => {
          setEsercizio(data)
        })
        .catch(error => console.error("Errore nel recupero dell'esercizio:", error));
    }
    setLoading(false)
  }, [id]);

  const handleChange = <K extends keyof Esercizio>(key: K, value: Esercizio[K]) => {
    setEsercizio(prev => ({ ...prev, [key]: value }));
  };



  const eliminaEsercizio = async () => {
    setLoading(true)
    if (!id) return;
    try {
      const headers = new Headers();
      //if (token) {
      //  headers.set('Authorization', `Token ${token}`);
      //}
      const response = await fetch(`/api/v0/activity/${id}`, {
        method: "DELETE",
        headers: headers,
        credentials: 'include',
      });
      if (!response.ok) {
        throw new Error("Errore durante l'eliminazione dell'esercizio");
      }
      navigate("/esercizi");
    } catch (error: any) {
      console.error("Errore durante la chiamata DELETE:", error);
      setModalData({
        show: true,
        title: "",
        message: error.message || "Si è verificato un errore durante l'eliminazione dell'esercizio",
        type: MODALTYPE.OK,
      })
    }
    setLoading(false)
  };

  const Modifica = () => {
    navigate("edit")
  }

  const isDraft = () => {
    return esercizio.status === "Draft";
  };

  const isValidEsercizio = () => {
    return (
      esercizio.full_name?.trim() &&
      esercizio.full_description?.trim() &&
      esercizio.position &&
      esercizio.purpose &&
      esercizio.execution &&
      esercizio.mode &&
      esercizio.muscle_groups?.length > 0 &&
      esercizio.posture &&
      esercizio.equipment &&
      esercizio.gravity_management_complexity > 0 &&
      esercizio.motor_coordination_complexity > 0 &&
      esercizio.cardiorespiratory_complexity > 0
    );
  };

  const aggiornaPubblicazione = async () => {
    setLoading(true)
    const nuovoStatus = esercizio.status === "Published" ? (isValidEsercizio() ? "Publishable" : "Draft") : "Published";

    try {
      const method = 'PUT';
      const headers = new Headers();
      //if (token) {
      //  headers.set('Authorization', `Token ${token}`);
      //}
      let formData = new FormData();
      formData.append('fields', JSON.stringify({ status: nuovoStatus }))

      const requestInit: RequestInit = {
        method,
        headers: headers,
        body: formData,
        credentials: 'include',
      };
      const response = await fetch(`/api/v0/activity/${id}/partial-update`, requestInit);

      if (!response.ok) {
        const errorData = await response.json();
        const messages = Object.entries(errorData)
          .map(([field, errors]) => `${field}: ${Array.isArray(errors) ? errors.join(', ') : errors}`)
          .join('\n');
        throw new Error(messages);
      }

      const data = await response.json();
      setEsercizio(data);
      console.log("Esercizio aggiornato:", data);
      navigate('/esercizi')
    } catch (error: any) {
      console.error("Errore durante la chiamata API:", error);
      setModalData({
        show: true,
        title: "",
        message: error.message || "Errore durante il salvataggio dell'esercizio",
        type: MODALTYPE.OK,
      })
    }
    setLoading(false)
  };



  const statoBadge = esercizio.status === "Published"
    ? <span className="badge text-bg-success">Pubblicato</span>
    : <span className="badge text-bg-danger">Non pubblicato</span>;


  const closeModal = () => setModalData(prev => ({ ...prev, show: false }));

  if (loading) {
    return (
      <SpinnerODM />
    )
  }

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: "#f3f3f3" }}>
      <div className="p-4 shadow-sm" style={{ flexShrink: 0 }}>
        <button className="btn btn-light" onClick={() => navigate('/esercizi')} style={{ whiteSpace: 'nowrap' }}>
          <ArrowBackIcon /> Torna indietro
        </button>
        <div className='row justify-content-between mt-5'>
          <div className='col-4 d-flex'>
            <h1 style={{ whiteSpace: 'nowrap' }}>{esercizio.full_name}</h1>
            <div className='mt-3 ms-5'>
              {statoBadge}
            </div>
          </div>
          <div className='col-4 d-flex justify-content-end'>
            <div className='m-3'>
              <button className="btn btn-danger" onClick={() => {
                const deleteExercice = async () => {
                  await eliminaEsercizio();
                }
                setModalData({
                  show: true,
                  title: "Elimina elemento",
                  message: "Se decidi di procedere, questo elemento verrà eliminato definitivamente dal backoffice.",
                  type: MODALTYPE.DELETE,
                  action: deleteExercice
                })
              }} style={{ whiteSpace: 'nowrap' }}>
                <DeleteIcon />
              </button>
            </div>
            <div className='m-3'>
              <button className="btn btn-light" onClick={Modifica} style={{ whiteSpace: 'nowrap' }}>
                <IosShareIcon /> Modifica
              </button>
            </div>
            <div className='m-3'>
              <button className="btn btn-light" onClick={aggiornaPubblicazione} disabled={isDraft()} style={{ whiteSpace: 'nowrap' }}>
                <PhoneIphoneIcon />{esercizio.status === "Published" ? "Disattiva in app" : "Pubblica in app"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='m-5'>
        <div className="row row-cols-1 row-cols-lg-2 g-3">
          <div className="col white-panel p-3" style={{ height: "60vh", overflowY: "auto" }}>
            <EsercizioDetailsTable esercizio={esercizio} />
          </div>

          <div className="col">
            <div className="white-panel p-3">
              <CompartiMuscolari
                title="Comparti muscolari*"
                field="muscle_groups"
                value={esercizio.muscle_groups}
                onChange={handleChange}
                edit={false}
              />
            </div>

            <div className="row row-cols-2 mt-3">
              <div className="col">
                <div className="white-panel p-3">
                  {esercizio.video ? (
                    <>
                      <h5>Video in app</h5>
                      <video
                        src={typeof esercizio.video === 'string' ? esercizio.video : URL.createObjectURL(esercizio.video)}
                        controls
                        style={{ width: "100%", marginBottom: "1rem" }}
                      />
                    </>
                  ) : (
                    <>
                      <h5>Video in app</h5>
                      <p>Nessun file caricato</p>
                    </>
                  )}
                </div>
              </div>
              <div className="col">
                <div className="white-panel p-3">
                  {esercizio.body_tracking ? (
                    <>
                      <h5>Body tracking (.json)</h5>
                      <textarea disabled className="form-control">{esercizio.body_tracking}</textarea>
                    </>
                  ) : (
                    <>
                      <h5>Body tracking (.json)</h5>
                      <p>Nessun file caricato</p>
                    </>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <ModalAlert
        modalData={modalData}
        onClose={closeModal} />
    </div >
  );
};

export default EsercizioPageV;